import { useEffect, createContext, useContext } from 'react';

type SubscribeToWhenChangeFunction = (when: boolean) => void;
export type Subscriber = {
  handleWhenChanged: SubscribeToWhenChangeFunction;
  unsubscribe: () => void;
};

export const AdditionalSubscribersContext = createContext<Subscriber[]>([]);

const tryToPreventUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  /* eslint-disable-next-line @typescript-eslint/no-deprecated -- I don't know if we still want to support older browsers but keeping this for now */
  event.returnValue = '';
  return '';
};

const beforeUnloadSubscriber: Subscriber = {
  handleWhenChanged: (when) => {
    if (when) {
      window.addEventListener('beforeunload', tryToPreventUnload, { capture: true });
    } else {
      window.removeEventListener('beforeunload', tryToPreventUnload, { capture: true });
    }
  },

  unsubscribe: () => {
    window.removeEventListener('beforeunload', tryToPreventUnload, { capture: true });
  },
};

const defaultSubscribers = [beforeUnloadSubscriber];

export const usePromptBeforeNavigation = ({ when }: { when: boolean }): void => {
  const additionalSubscribers = useContext(AdditionalSubscribersContext);

  useEffect(() => {
    const subscribers = [...defaultSubscribers, ...additionalSubscribers];

    subscribers.forEach((subscriber) => {
      subscriber.handleWhenChanged(when);
    });

    return () => {
      subscribers.forEach((subscriber) => {
        subscriber.unsubscribe();
      });
    };
  }, [when, additionalSubscribers]);
};
